import { render } from "./NidView.vue?vue&type=template&id=21c4016e&scoped=true"
import script from "./NidView.vue?vue&type=script&lang=js"
export * from "./NidView.vue?vue&type=script&lang=js"

import "./NidView.vue?vue&type=style&index=0&id=21c4016e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c4016e"]])

export default __exports__